import { IdNomeDTO } from '@/interfaces/base-dto';
import IPrescription from '@/interfaces/prescription';
import { ITranscription } from '@/interfaces/transcription';
import { WAITING_TRANSCRIPTION } from '@/settings/consts/transcription-status';

export default class TranscriptionModel {
  public id?: string;
  public prescricoes: IPrescription[];
  public prescricaoAprovada: IPrescription;
  public prescricaoReferencia: IPrescription;
  public prescricaoAguardandoAprovacao: IPrescription;
  public status: string;
  public iniciadoPor: string;
  public transcritorAtual: any;
  public emProgresso: boolean;
  public matches: string;
  public minMatches: string;
  public podeTranscrever: boolean;
  public unidade?: IdNomeDTO;
  public paciente?: IdNomeDTO;
  public dataInclusao: string;  

  constructor(_initialValue?: ITranscription) {
    const initialValue = _initialValue || {
      id: null,
      prescricoes: [],
      status: WAITING_TRANSCRIPTION.key,
      prescricaoAprovada: null,
      prescricaoReferencia: null,
      prescricaoAguardandoAprovacao: null,
      iniciadoPor: null,
      transcritorAtual: {},
      emProgresso: false,
      matches: null,
      minMatches: null,
      podeTranscrever: true,
      unidade: null,
      paciente: null,
      dataInclusao: null,
    };

    this.id = initialValue.id;
    this.prescricoes = initialValue.prescricoes;
    this.prescricaoAprovada = initialValue.prescricaoAprovada;
    this.status = initialValue.status;
    this.iniciadoPor = initialValue.iniciadoPor;
    this.transcritorAtual = initialValue.transcritorAtual;
    this.emProgresso = initialValue.emProgresso;
    this.matches = initialValue.matches;
    this.minMatches = initialValue.minMatches;
    this.prescricaoAguardandoAprovacao =
      initialValue.prescricaoAguardandoAprovacao;
    this.prescricaoReferencia = initialValue.prescricaoReferencia;
    this.podeTranscrever = initialValue.podeTranscrever;
    this.unidade = initialValue.unidade;
    this.paciente = initialValue.paciente;
    this.dataInclusao = initialValue.dataInclusao;
  }

  public toJson(): any {
    return {
      id: this.id,
      prescricoes: this.prescricoes,
      prescricaoAprovada: this.prescricaoAprovada,
      status: this.status,
      iniciadoPor: this.iniciadoPor,
      emProgresso: this.emProgresso,
    };
  }
}
